import { render, staticRenderFns } from "./pie-value.vue?vue&type=template&id=587393c4&scoped=true"
import script from "./pie-value.vue?vue&type=script&lang=js"
export * from "./pie-value.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587393c4",
  null
  
)

export default component.exports